module.exports = __webpack_public_path__ + "img/frame (17).80734d76.jpg";